import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import { CreditCardsSelectType, CreditCardInput, CreditCardSelectMonth, CreditCardSelectYear } from './'
import { InputWithErrors } from '../../lib/forms';
import { isRequired, isCreditCard, number } from '../../lib/forms/Validations';
import { Payment } from '../../services';

class PaymentForm extends Component{

  render(){
      const { translate, handleSubmit, cancel } = this.props;
    return(
      <div>
        <form className="form-line form-payment edit" onSubmit={handleSubmit} >
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card card-payment">
                <div className="card-block">
                  <div className="row">
                    <div className="col-8 col-md-7">
                      <div className="form-group">
                        <label>{translate('card-holder')}</label>
                          <Field name="cc_name" className="form-control" placeholder={translate('card-holder')} translate={translate} component={InputWithErrors} type="text" validate={[ isRequired,]} />
                      </div>
                    </div>
                    <div className="col-8 col-md-5 text-md-right">
                      <div className="form-group form-group-payment-type">
                        <label>type</label>
                        <Field name="cc_type" className="form-group" translate={translate} component={CreditCardsSelectType} type="tel" validate={[ isRequired]} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="form-group form-group-payment-number ">
                        <label>{translate('number')}</label>
                        <div className="row ">
                          <Field name="cc_number" component={CreditCardInput} translate={translate} validate={[ isRequired, isCreditCard ]} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4 col-md-4">
                      <div className="form-group form-group-payment-type" >
                        <label>{translate('teudat-zeut')}</label>
                          <Field name="cc_tz" className="form-control" placeholder="011111110" translate={translate} maxlength="9" component={InputWithErrors} type="tel" validate={[ number]} />
                      </div>
                    </div>
                    <div className="col-3 col-md-3">
                      <div className="form-group form-group-payment-type" >
                        <label>cvv</label>
                          <Field name="cc_cvv" className="form-control" placeholder="123" translate={translate} maxlength="4" component={InputWithErrors} type="tel" validate={[ isRequired, number]} />
                      </div>
                    </div>
                    <div className="col-5 col-md-5 text-md-right">
                      <div className="form-group form-group-payment-expiration" >
                        <label>{translate('expiration-date')}</label>
                        <div className="row">
                          <div className="col pr-0">
                            <Field name="cc_expiration_month" placeholder="2000" className="form-group" translate={translate} component={CreditCardSelectMonth} type="tel" validate={[ isRequired]} />
                          </div>
                          <div className="col pl-0">
                            <Field name="cc_expiration_year"  className="form-group" translate={translate} component={CreditCardSelectYear} type="tel" validate={[ isRequired]} />
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-end row-btn">
                <div className="col-6 col-md-3">
                  <button className="btn btn-block btn-form btn-cancel" type="button" onClick={ () => cancel() }>{translate('cancel')}</button>
                </div>
                <div className="col-6 col-md-3">
                  <button className="btn btn-block btn-form btn-submit" type="submit" data-target=".bd-example-modal-lg" data-toggle="modal" >{translate('save')}</button>
                </div>
              </div>
          <div className="row justify-content-end row-btn">
          </div>
        </form>
      </div>
    )
  }
}

PaymentForm = reduxForm({
 form: 'payment',
 enableReinitialize: true
})(PaymentForm)

class PaymentFormHandler extends Component {
  handleSubmit(values) {
    const { setFlashMessage, translate, history } = this.props;
    Payment.postPaymentMethod(values)
    .then((res) => {
      setFlashMessage(`${translate('changes-saved-successfully')}`, true)
      history.goBack();
    })
    }
    cancel(values) {
      const {  setFlashMessage, translate, history } = this.props;
      setFlashMessage( translate('cancel'), false)
      history.goBack();
    }

  render() {
    const { translate } = this.props;
    return (
      <div>
        <PaymentForm translate={translate} onSubmit={this.handleSubmit.bind(this)} cancel={this.cancel.bind(this)}/>
      </div>
    );
  }
}
const HandlerViewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const HandlerViewMapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  };
};
PaymentFormHandler = connect(
  HandlerViewMapStateToProps,
  HandlerViewMapDispatchToProps,
)(PaymentFormHandler);

PaymentFormHandler = withRouter(PaymentFormHandler);

export default PaymentFormHandler;



// WEBPACK FOOTER //
// ./src/components/Payment/PaymentForm.js